// Sidebar
export const SIDEBAR_VISIBILITY_TOGGLE = "SIDEBAR/VISIBILITY_TOGGLE";
export const SIDEBAR_VISIBILITY_SHOW = "SIDEBAR/VISIBILITY_SHOW";
export const SIDEBAR_VISIBILITY_HIDE = "SIDEBAR/VISIBILITY_HIDE";
export const SIDEBAR_STICKY_TOGGLE = "SIDEBAR/STICKY_TOGGLE";
export const SIDEBAR_STICKY_ENABLE = "SIDEBAR/STICKY_ENABLE";
export const SIDEBAR_STICKY_DISABLE = "SIDEBAR/STICKY_DISABLE";

// Layout
export const LAYOUT_BOXED_TOGGLE = "LAYOUT/BOXED_TOGGLE";
export const LAYOUT_BOXED_ENABLE = "LAYOUT/BOXED_ENABLE";
export const LAYOUT_BOXED_DISABLE = "LAYOUT/BOXED_DISABLE";

// Theme
export const THEME_TOGGLE = "THEME/TOGGLE";

// User
export const USER_TOKEN_NAME = "mbEonsAuthToken";
export const ADMIN_TOKEN_NAME = "mbEonsAuthToken_ADMIN";
export const INTERNAL_TOKEN_NAME = "mbInternal";
export const USER_DESIRED_PAGE = "mbEonsDesiredPage";

export const USER_LOADING = "USER/LOADING";
export const USER_AVAILABLE = "USER/AVAILABLE";
export const LOAD_USER = "USER/LOAD";
export const REGISTER_USER = "USER/REGISTER";
export const LOGIN_USER = "USER/LOGIN";
export const SSO_USER = "USER/SSO";
export const LOGOUT_USER = "USER/LOGOUT";
export const UPDATE_USER = "USER/UPDATE";
export const DELETE_USER = "USER/DELETE";
export const AUTH_ERROR = "AUTH/ERROR";

// Admin
export const ADMIN_LOADING = "ADMIN/LOADING";
export const STORE_USER = "ADMIN/STORE_USER";
export const SET_USERS = "ADMIN/SET_USERS";
export const SELECT_USER = "ADMIN/SELECT_USER";
export const SET_APPROVERS = "ADMIN/SET_APPROVERS";
export const SELECT_APPROVER = "ADMIN/SELECT_APPROVER";
export const SET_WHITELIST = "ADMIN/SET_WHITELIST";
export const SELECT_WHITELIST = "ADMIN/SELECT_WHITELIST";
export const SET_SUPPRESSIONLIST = "ADMIN/SET_SUPPRESSIONLIST";
export const SELECT_SUPPRESSIONLIST = "ADMIN/SELECT_SUPRESSIONLIST";
export const SET_SEEDS = "ADMIN/SET_SEEDS";
export const SELECT_SEED = "ADMIN/SELECT_SEED";
export const ADMIN_ERROR = "ADMIN/ERROR";

// Campaign Options
export const SET_EMAIL_OPTIONS = "CAMPAIGN/SET_EMAIL_OPTIONS";
export const SET_PUSH_OPTIONS = "CAMPAIGN/SET_PUSH_OPTIONS";

// Campaigns
export const CAMPAIGN_LOADING = "CAMPAIGNS/LOADING";
export const SET_CAMPAIGNS = "CAMPAIGNS/SET";
export const RESET_CAMPAIGNS = "CAMPAIGNS/RESET";
export const SELECT_CAMPAIGN = "CAMPAIGN/SELECT";
export const UPDATED_CAMPAIGN = "CAMPAIGN/UPDATE";
export const DELETE_CAMPAIGN = "CAMPAIGN/DELETE";
export const REPORT_REFRESHED = "CAMPAIGN/REPORT_REFRESHED";
export const SET_CAMPAIGN_TEMPLATES = "CAMPAIGNS/SET_TEMPLATES";
export const SELECT_FOLDER = "CAMPAIGN/SELECT_FOLDER";
export const SET_CAMPAIGN_FOLDERS = "CAMPAIGNS/SET_FOLDERS";
export const SET_CAMPAIGN_TAGS = "CAMPAIGNS/SET_TAGS";
export const SET_NESTED_CAMPAIGN_FOLDERS = "CAMPAIGNS/SET_NESTED_FOLDERS";
export const SET_CALLER_IDS = "CAMPAIGNS/SET_CALLER_IDS";
export const CALLER_ID_USAGE_DETAILS = "CAMPAIGN/CALLER_ID_USAGE_DETAILS";
export const SET_CAMPAIGN_TYPES = "CAMPAIGN/TYPES";
export const SET_CAMPAIGN_SUBTYPES = "CAMPAIGN/SUBTYPES";
export const CAMPAIGN_ERROR = "CAMPAIGNS/ERROR";
export const CLEAR_CAMPAIGN_ERROR = "CAMPAIGNS/CLEAR_ERROR";
export const WAV_FILE_UPLOAD = "CAMPAIGNS/WAVE_FILE_UPLOAD";
export const REMOVE_WAV_FILE = "CAMPAIGNS/REMOVE_WAV_FILE";
export const LOAD_SAVED_FILES = "CAMPAIGNS/LOAD_SAVED_FILES";
export const REMOVE_FILES = "CAMPAIGNS/REMOVE_FILES";
export const WAV_FILE_ERROR = "CAMPAIGNS/WAV_FILE_ERROR";
export const SHORTEN_URL_SMS = "CAMPAIGNS/SHORTEN_URL_SMS";
export const SHORTEN_URL_EMAIL = "CAMPAIGNS/SHORTEN_URL_EMAIL";
export const SHORTEN_URL_SMS_ERROR = "CAMPAIGNS/SHORTEN_URL_SMS_ERROR";
export const SHORTEN_URL_EMAIL_ERROR = "CAMPAIGNS/SHORTEN_URL_EMAIL_ERROR";

// Data
export const DATA_LOADING = "DATA/LOADING";
export const DATASET_DOWNLOADING = "DATASET/DOWNLOADING";
export const DATASET_UPLOAD_PROGRESS = "DATASET/UPLOADPROGRESS";
export const SET_DATA_SUMMARY = "DATA/SUMMARY";
export const SET_DATASETS = "DATASETS/SET";
export const SET_DATASET = "DATASETS/SELECT";
export const APPLY_MAPPED_COLUMNS = "DATASET/MAPPED_COLUMNS";
export const SET_FILTERS = "DATASETS/SET_FILTER";
export const CREATE_DATASET = "DATASET/CREATED";
export const DELETE_DATASET = "DATASETS/DELETE";
export const UPLOAD_DATASET_FILE = "DATASETS/UPLOAD_FILE";
export const REMOVE_DATASET_FILE = "DATASETS/REMOVE_FILE";
export const RESET_DATASETS = "DATASETS/RESET";
export const DATASET_ERROR = "DATASETS/ERROR";
